import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { QbInputModule } from '@fwmovilidad/qb-lib-ng-components';
// Components across the app
import { ModalCallMeComponent } from './modal-call-me.component';
import { MatDialogModule } from '@angular/material/dialog';
import { IonicModule } from '@ionic/angular';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    QbInputModule,
    MatDialogModule,
  ],
  declarations: [
    ModalCallMeComponent,
  ],
  exports: [
    ModalCallMeComponent,
  ],
})
export class ModalCallMeModule { }
